import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {

  constructor(private router: Router
  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return next.data.roles.some(val => {
      if (!next.data.roles.includes(localStorage.getItem('roleName')) ) {
        this.router.navigate(['/access-restriction-page']);
      }
      return localStorage.getItem('roleName').includes(val);

    });
  }

}
